/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAdminCreateUserResponse
 */
export interface ControlAdminCreateUserResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlAdminCreateUserResponse
     */
    activation_token: string;
}

/**
 * Check if a given object implements the ControlAdminCreateUserResponse interface.
 */
export function instanceOfControlAdminCreateUserResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "activation_token" in value;

    return isInstance;
}

export function ControlAdminCreateUserResponseFromJSON(json: any): ControlAdminCreateUserResponse {
    return ControlAdminCreateUserResponseFromJSONTyped(json, false);
}

export function ControlAdminCreateUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAdminCreateUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activation_token': json['activation_token'],
    };
}

export function ControlAdminCreateUserResponseToJSON(value?: ControlAdminCreateUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activation_token': value.activation_token,
    };
}

